import {handleActions} from 'redux-actions'
import * as ActionTypes from "./actionTypes"
import {CLOSE_ALL_PANELS} from '../../../administration/userManagement/common/actionTypes'

const initialState = {
    show: false,
}

export default handleActions({
    [ActionTypes.SHOW_SET]: (state, {payload: show}) => ({
        ...state,
        show
    }),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        show: false,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/panels/user/createTeamAssignmentsPanel/reducer.js